import STORAGE_KEYS from "@src/constants/storageKeys";
import { Navigate, Outlet } from "react-router-dom";

interface RouteGuardProps {
  canActivate: () => boolean;
  allowedRoles?: string[];
  redirectTo?: string;
}

const RouteGuard = ({ canActivate, redirectTo = "/auth/login" }: RouteGuardProps) => {
  const userRole = !!localStorage.getItem(STORAGE_KEYS.auth_details)
  if (!userRole) {
    return <Navigate to={redirectTo} replace />;
  }
  if (!canActivate() && userRole) {
    return <Navigate to="/404" replace />;
  }
  // if (allowedRoles && !allowedRoles.includes(userRole ?? "")) {
  //   return <Navigate to="/unauthorized" replace />;
  // }
  return <Outlet />;
};

export default RouteGuard;
